module.exports = __webpack_public_path__ + "static/media/Store-calendar-banner-mobile.77c041de.jpg";